function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1996(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 5.25,
    height: 5.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 2.86
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.72,
    width: 5.25,
    height: 15.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 13.675
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.63,
    width: 5.25,
    height: 38.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 40.69
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.75,
    width: 5.25,
    height: 40.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 79.8
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 99.85,
    width: 5.25,
    height: 52.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 126
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 152.15,
    width: 5.25,
    height: 54.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 179.60500000000002
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 207.06,
    width: 5.25,
    height: 70.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 242.325
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.59,
    width: 5.25,
    height: 74.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.65625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 314.625
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 351.67,
    width: 5.25,
    height: 82.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 392.98
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 434.29,
    width: 5.25,
    height: 82.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.5833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 475.70500000000004
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 517.12,
    width: 5.25,
    height: 90.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 562.55
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 607.98,
    width: 5.25,
    height: 92.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.625,
    y: 653.99
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 0,
    width: 18.03,
    height: 37.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8030000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.265,
    y: 18.855
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.28,
    y: 0,
    width: 18.74,
    height: 37.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.123333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.65,
    y: 18.855
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.03,
    y: 0,
    width: 20.06,
    height: 37.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.06,
    y: 18.855
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.09,
    y: 0,
    width: 22.31,
    height: 37.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4788888888888887
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.245,
    y: 18.855
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.4,
    y: 0,
    width: 23.72,
    height: 37.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.26,
    y: 18.855
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.13,
    y: 0,
    width: 26.51,
    height: 37.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.418333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.38499999999999,
    y: 18.855
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.64,
    y: 0,
    width: 27.67,
    height: 37.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.475,
    y: 18.855
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.31,
    y: 0,
    width: 28.5,
    height: 37.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.56,
    y: 18.855
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.8,
    y: 0,
    width: 32.09,
    height: 37.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.348333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.84500000000003,
    y: 18.855
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.9,
    y: 0,
    width: 33.48,
    height: 37.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.64000000000001,
    y: 18.855
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.38,
    y: 0,
    width: 34.24,
    height: 37.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.5,
    y: 18.855
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.61,
    y: 0,
    width: 39.77,
    height: 37.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.495,
    y: 18.855
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.38,
    y: 0,
    width: 42.4,
    height: 37.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.58,
    y: 18.855
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.78,
    y: 0,
    width: 56.05,
    height: 37.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.80499999999995,
    y: 18.855
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.83,
    y: 0,
    width: 60.87,
    height: 37.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 459.265,
    y: 18.855
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.7,
    y: 0,
    width: 62.66,
    height: 37.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.4275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.03,
    y: 18.855
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.37,
    y: 0,
    width: 72.31,
    height: 37.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.71375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.525,
    y: 18.855
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.68,
    y: 0,
    width: 75.32,
    height: 37.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.4275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.3399999999999,
    y: 18.855
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 37.71,
    width: 68.76,
    height: 44.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.463333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 60.1
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 82.49,
    width: 68.76,
    height: 44.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.993333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 104.96
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 127.43,
    width: 68.76,
    height: 56.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.314
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 155.715
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 184.01,
    width: 68.76,
    height: 61.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.174999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 214.535
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 245.06,
    width: 68.76,
    height: 67.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.193333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 278.64
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 312.21,
    width: 68.76,
    height: 71.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5840000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 347.945
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 383.69,
    width: 68.76,
    height: 73.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.876
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 420.34
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 456.98,
    width: 68.76,
    height: 77.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 495.58500000000004
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 534.19,
    width: 68.76,
    height: 82.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.752
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 575.49
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 616.79,
    width: 68.76,
    height: 83.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.876
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.63,
    y: 658.395
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.01,
    y: 37.71,
    width: 59.91,
    height: 95.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.985
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.965,
    y: 85.58
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 37.71,
    width: 74.14,
    height: 95.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.98999999999998,
    y: 85.58
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.06,
    y: 37.71,
    width: 77,
    height: 95.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.923076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.56,
    y: 85.58
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.07,
    y: 37.71,
    width: 87.55,
    height: 95.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.8875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.84499999999997,
    y: 85.58
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.62,
    y: 37.71,
    width: 92.61,
    height: 95.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.925,
    y: 85.58
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.23,
    y: 37.71,
    width: 106.45,
    height: 95.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.956666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.455,
    y: 85.58
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.68,
    y: 37.71,
    width: 128.32,
    height: 95.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.677142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 635.8399999999999,
    y: 85.58
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.01,
    y: 133.45,
    width: 111.02,
    height: 110.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.31111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.52,
    y: 188.85
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.01,
    y: 244.25,
    width: 111.02,
    height: 127.92,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.52,
    y: 308.21
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.01,
    y: 372.17,
    width: 111.02,
    height: 155.32,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.251666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.52,
    y: 449.83000000000004
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.01,
    y: 527.49,
    width: 111.02,
    height: 172.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.335555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.52,
    y: 613.745
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.03,
    y: 133.45,
    width: 116.16,
    height: 171.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.11,
    y: 219.20999999999998
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.2,
    y: 133.45,
    width: 117.86,
    height: 171.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.418571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.13,
    y: 219.20999999999998
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.05,
    y: 133.45,
    width: 131.74,
    height: 171.52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.92,
    y: 219.20999999999998
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.8,
    y: 133.45,
    width: 149.2,
    height: 171.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.563636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.4,
    y: 219.20999999999998
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.03,
    y: 304.96,
    width: 216.49,
    height: 195.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.55166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.275,
    y: 402.615
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.03,
    y: 500.27,
    width: 216.49,
    height: 199.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.19222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.275,
    y: 600.135
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.52,
    y: 304.96,
    width: 298.48,
    height: 395.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.134545454545457
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.76,
    y: 502.48
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1996);
export default __webpack_public_path__ + "static/media/1996.6d2e5f964a7249e47919e20c2ecbfe54.svg";
export { ForwardRef as ReactComponent };